wbApp.factory('rentItemAvailabilitySvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var RentItemAvailability = $resource('/restapi/item-types/:id', {}, {
            'getAllByPlaceAndRentCategoryAndTypeAndDateRange': { method: 'GET', url: '/restapi/rent-item-availability/range/find-by-place-and-rent-category-and-item-type' },
        });


        // groupBy: [GroupByRentCategory|GroupByRentItem]
        function getAllByPlaceAndRentCategoryAndTypeAndDateRange(
            placeId,
            rentCategoryId,
            itemTypeId,
            fromDateUtc,
            toDateUtc,
            groupBy)
        {
            return repositorySvc.customGet(
                'getAllByPlaceAndRentCategoryAndTypeAndDateRange',
                RentItemAvailability,
                {
                    placeId: placeId,
                    rentCategoryId: rentCategoryId,
                    itemTypeId: itemTypeId,
                    fromDateUtc: moment(fromDateUtc).startOf('day').utc().format(),
                    toDateUtc: moment(toDateUtc).endOf('day').utc().format(),
                    groupBy: groupBy
                });
        }

        return {
            getAllByPlaceAndRentCategoryAndTypeAndDateRange: getAllByPlaceAndRentCategoryAndTypeAndDateRange
        }
    }
]);